import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import s from './ModelVariantSetpoints.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { initialModelVariantState } from '../../reducers/initialState';
import ModelVariantSetpointsListTable from './ModelVariantSetpointsListTable';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import SearchBar from '../SearchBar/SearchBar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { getModelCategoryPermission, sortSetpoints } from '../../utils';
import { useParams } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE, ModelCategoryPermission } from '../../constants';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import Breadcrumb from '../WSAControls/Breadcrumb/BreadCrumb';
import ModelVariantConfigurationContentTemplate from '../ModelVariantConfiguration/ModelVariantConfigurationContentTemplate';
import Pagination from '../Pagination/Pagination';
import Cookies from 'js-cookie';


const ModelVariantSetpointsList = ({
  modelVariantSetpoints = { ...initialModelVariantState.modelVariantManager.selectedModelVariant.Setpoints },
  intl,
  userProfileWidgets,
  getModelVariantSetpoints,
  saveModelVariantSetpoint,
  changeModelVariantSetpoint,
  setModelVariantSetpointShowScreenStatus,
  userModelCategories,
  setCurrentPage
}) => {

  let { ModelCategoryId, ModelId, ModelVariantId } = useParams();
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;

  useEffect(() => {
    getModelVariantSetpoints(ModelVariantId, ModelId);
  }, [getModelVariantSetpoints, ModelVariantId, ModelId]);

  const [currentEditId, setCurrentEditId] = useState(-1);
  const [searchText, setSearchText] = useState('');
  const [active, setActive] = useState(false);
  const [modelSetpointId, setModelSetpointId] = useState(0);

  const onPageChangeHandler = currentPage => {
    setCurrentPage(currentPage);
  };


  const searchHandler = value => {
    setCurrentPage(1);
    setSearchText(value);
  };
  const disableModeHandler = status => {
    setModelVariantSetpointShowScreenStatus(status);
  };


  const setEditHandler = modelVariantSetpointId => {
    setCurrentEditId(modelVariantSetpointId);
    if (modelVariantSetpointId === -1) {
      changeModelVariantSetpoint({
        ...modelVariantSetpoints,
        SelectedSetpoint: {
          ...initialModelVariantState.modelVariantManager.selectedModelVariant.Setpoints,
          ModelId: ModelId,
          ModelVariantSetpointId: modelVariantSetpointId || 0,
          ModelVariantId: ModelVariantId,
        }

      });
      setModelVariantSetpointShowScreenStatus(false);
    } else {
      setModelVariantSetpointShowScreenStatus(true);
    }
  };

  const filterData = () => {
    let filteredList = modelVariantSetpoints.SetpointsList;

    filteredList = modelVariantSetpoints.SetpointsList.filter(function (item) {
      return item.Name.toLowerCase().includes(searchText.toLowerCase());
    });


    return filteredList;
  };

  const defaultHandler = (id) => {
    setActive(true);
    setModelSetpointId(id);
  };

  const defautModelSetpoint = () => {

    let saveData = modelVariantSetpoints.SelectedSetpoint;
    saveData.PerformResetDefault = true;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;
    saveData.ModelId = ModelId;
    saveData.ModelVariantId = ModelVariantId;
    saveData.ModelVariantSetpointId = modelSetpointId;
    saveModelVariantSetpoint(saveData, 'MODELVARIANTSETPOINTSEDIT');
  };

  const handleClose = () => {
    setActive(false);
    setModelSetpointId(0);
  };

  const handleConfirm = () => {
    defautModelSetpoint();
    handleClose();
  };


  let messageId = (modelVariantSetpoints && modelVariantSetpoints.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });
  const dialogTitle = intl.formatMessage({
    id: 'modelVariantSetpoints.setDefaultConfirm',
    defaultMessage: 'Are you sure you want to set this setpoint to default?'
  });

  const isUpdateAllowed = IsWidgetAccessible(userProfileWidgets, 'MODELVARIANTSETPOINTSEDIT') || IsWidgetAccessible(userProfileWidgets, 'MODELVARIANTSETPOINTSADD');


  const breadcrumbItems = [
    { label: <FormattedMessage id="modelcategory.modelcategory" defaultMessage="Model Category" />, href: '/operational-setup/model-category-list' },
    { label: <FormattedMessage id="model.models" defaultMessage="Models" />, href: `/operational-setup/model-category-configuration/${ModelCategoryId}/model-list` },
    { label: <FormattedMessage id="model.modelvariant" defaultMessage="Model Variant" />, href: `/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variants-list` },
    { label: <FormattedMessage id="modelVariantSetpoints.manageModelVariantSetpoint" defaultMessage="Manage Model Variant Setpoints" /> } // Last item has no href (current page)
  ];

  let isModelCategoryOwner = getModelCategoryPermission(userModelCategories, ModelVariantId, ModelCategoryPermission.Owner)
  const dataObj = Object.values(filterData());


  return (
    <div className={s.modelVariantSetpoints}>
      {modelVariantSetpoints.isLoading && <LoadingSpinner />}
      {modelVariantSetpoints.showBanner && (
        <Banner
          failureText={messageText}
          showBanner={modelVariantSetpoints.showBanner}
          status={modelVariantSetpoints.isOpSuccessfull}
          successText={messageText}
        />
      )}
      <ConfirmDialog title={dialogTitle} onConfirm={handleConfirm} onClose={handleClose} showDialog={active} />
      <ModelVariantConfigurationContentTemplate selectedPage="manageModelVariantsSetpoints" userProfileWidgets={userProfileWidgets} intl={intl}>
        <div className={s.contentWrapper}>
          <div className={s.componentHeader}>
            <div className={s.subHeading}>
              <FormattedMessage id="modelVariantSetpoints.manageModelVariantSetpoint" defaultMessage="Manage Model Variant Setpoints" />
              <span className={s.circle}>
                {modelVariantSetpoints.SetpointsList.length}
              </span>
            </div>
          </div>
          <div className='pb-3'>
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <Row className={s.topRow}>
            <Col sm={6} lg={4}>
              <SearchBar
                searchHandler={searchHandler}
                clearSearchInVisible={false}
                disabled={modelVariantSetpoints.showAddEditScreen}
                placeHolderTextId="model.search"
                data-unittest="searchModelVariantSetpoints"
              />
            </Col>
          </Row>

          <div>
            <Pagination
              data={sortSetpoints(dataObj)}
              pageSize={DEFAULT_PAGE_SIZE}
              onPageChange={onPageChangeHandler}
              startingPage={modelVariantSetpoints.currentPage}>
              <ModelVariantSetpointsListTable
                setEditHandler={setEditHandler}
                defaultHandler={defaultHandler}
                selectedModelSetpointId={currentEditId}
                saveModelVariantSetpoint={saveModelVariantSetpoint}
                modelVariantSetpoints={modelVariantSetpoints}
                changeModelVariantSetpoint={changeModelVariantSetpoint}
                UpdateAllowed={isUpdateAllowed}
                disableMode={modelVariantSetpoints.showAddEditScreen}
                disableModeHandler={disableModeHandler}
                IsModelCategoryOwner={isModelCategoryOwner}
              />
            </Pagination>
          </div>

        </div>
      </ModelVariantConfigurationContentTemplate >
    </div >
  );
};


ModelVariantSetpointsList.propTypes = {
  userProfileWidgets: PropTypes.object.isRequired,
  getModelVariantSetpoints: PropTypes.func.isRequired,
  saveModelVariantSetpoint: PropTypes.func.isRequired,
  describeModelVariantSetpoint: PropTypes.func.isRequired,
  changeModelVariantSetpoint: PropTypes.func.isRequired,
  setModelVariantSetpointShowScreenStatus: PropTypes.func.isRequired
};

export default injectIntl(ModelVariantSetpointsList);
